import { Component, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { of, Subject } from 'rxjs';
import { map, takeUntil, withLatestFrom } from 'rxjs/operators';
import { AppQueries } from './app.queries';
import { AuthService } from './lib/auth.service';
import { AgreementStatusesQueries } from './pages/shared/gui/agreement-statuses/agreement-statuses.queries';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnDestroy {
  private readonly destroy$ = new Subject<void>();
  private readonly agreementStatus$ = new Subject<void>();

  title = 'skipr-sp-client';
  // 同意フォームのフラグ
  showAgreementForm: boolean;

  constructor(
    private readonly appQueries: AppQueries,
    private readonly auth: AuthService,
    private readonly router: Router,
  ) {
    this.showAgreementForm = false;

    // 同意フォームの表示判定
    this.appQueries.agreementStatuses$
      .pipe(
        withLatestFrom(
          this.appQueries.privacyPolicy$,
          this.appQueries.termsOfService$,
          of(this.auth.isSignedIn()),
        ),
        map(
          ([agreementStatuses, privacyPolicy, termsOfService, isSignedIn]) =>
            !isSignedIn ||
            (agreementStatuses.privacyPolicy.eq(privacyPolicy.version) &&
              agreementStatuses.termsOfService.eq(termsOfService.version)),
        ),
        takeUntil(this.destroy$),
        takeUntil(this.agreementStatus$),
      )
      .subscribe((agreementStatus: boolean) => {
        this.showAgreementForm = !agreementStatus;
        if (agreementStatus) {
          this.agreementStatus$.next();
        }
      });

    // メンテナンスモードの監視
    this.appQueries.underMaintenance$
      .pipe(takeUntil(this.destroy$))
      .subscribe(underMaintenance => {
        if (underMaintenance) {
          this.router.navigateByUrl('/maintenance');
        }
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
  }
}
